<template>
    <EmployeeViewServiceReport></EmployeeViewServiceReport>
</template>
<script>
    import EmployeeViewServiceReport from '@/components/EmployeeViewServiceReport.vue'
    export default {
        name: 'employee-view-service-report',
        components: {
            EmployeeViewServiceReport
        }
    }
</script>